import { ERROR_CODE_PROVIDER_UNAVAILABLE as e, ERROR_CODE_SANDBOX_UNAVAILABLE as t, decodeStreamError as n } from "@livingdata/playground-core-shared";
import r, { isNetworkError as i } from "ky";
import a from "is-network-error";
import o from "p-retry";
//#region src/api-paths.ts
function s(e) {
	return `shared/artifacts/${e}`;
}
//#endregion
//#region src/api/index.ts
var c = class extends Error {
	code;
	explanation;
	constructor(e) {
		super(e.code), this.name = "ServerStreamError", this.code = e.code, this.explanation = e.explanation;
	}
}, l = class extends Error {
	constructor() {
		super("Credit balance exhausted"), this.name = "CreditExhaustedError";
	}
};
function u(e) {
	return e instanceof l;
}
var d = class extends Error {
	constructor(e) {
		super(e), this.name = "SandboxLimitError";
	}
};
function ee(e) {
	return e instanceof d;
}
function f(e) {
	if (e instanceof c) return e;
	if (e instanceof Error) {
		let t = n(e.message);
		if (t) return new c(t);
	}
}
function p(t) {
	return f(t)?.code === e;
}
function m(e) {
	return f(e)?.code === t;
}
function h(e) {
	return i(e) || a(e);
}
function g(e, t) {
	if (typeof e == "object" && e && t in e) {
		let n = e[t];
		if (typeof n == "string" && n.trim().length > 0) return n;
	}
}
async function _(e) {
	let { message: t } = await v(e);
	return t;
}
async function te(e, t) {
	try {
		return await e;
	} catch (e) {
		throw Error(await _(e) ?? t);
	}
}
async function v(e) {
	let t = e, n = {
		message: g(t?.data, "error"),
		code: g(t?.data, "code")
	};
	if (n.message !== void 0 || n.code !== void 0) return n;
	let { response: r } = t ?? {};
	if (r instanceof Response) try {
		let e = await r.clone().json();
		return {
			message: g(e, "error"),
			code: g(e, "code")
		};
	} catch {}
	return {};
}
var y;
function b(e) {
	y = e;
}
var x;
function S(e) {
	x = e;
}
async function C(e) {
	if (e.status === 403) try {
		let t = await e.clone().json();
		return g(t, "code") === "plans:no_plan" ? g(t, "error") ?? "" : void 0;
	} catch {
		return;
	}
}
var w, T, E = "http://localhost:3000";
function D() {
	return E;
}
function O(e, t) {
	return w(e, t);
}
function k({ apiUrl: e, credentials: t = "same-origin", retry: n = !0 }) {
	E = e, w = r.create({
		prefix: e,
		credentials: t,
		hooks: { afterResponse: [async ({ response: e }) => {
			if (e.status === 401 && y?.(), x) {
				let t = await C(e);
				t !== void 0 && x(t);
			}
		}] }
	}), T = w.extend({
		retry: {
			limit: n ? 3 : 0,
			methods: [
				"get",
				"post",
				"put",
				"patch"
			],
			statusCodes: [
				408,
				413,
				429,
				500,
				502,
				503,
				504
			]
		},
		timeout: 3e4
	});
}
k({ apiUrl: "http://localhost:3000" });
async function A() {
	return T.get("conversations").json();
}
async function j(e) {
	return T.get(`conversations/${e}`).json();
}
async function M() {
	return T.post("conversations", { json: {} }).json();
}
async function N(e) {
	await T.delete(`conversations/${e}`);
}
async function P(e, t) {
	return T.patch(`conversations/${e}/settings`, { json: t }).json();
}
async function F(e) {
	return T.post(`conversations/${e}/regenerate-title`).json();
}
async function I(e) {
	return T.get(`conversations/${e}/sandbox`).json();
}
async function L(e) {
	return T.post(`conversations/${e}/sandbox/pause`).json();
}
async function R(e, t) {
	return T.post(`conversations/${e}/evaluations`, {
		json: t,
		retry: 0
	}).json();
}
function z(e) {
	return `conversations/${e}/messages`;
}
function B(e) {
	return `conversations/${e}/stream`;
}
async function V(e) {
	await T.delete(`conversations/${e}/stream`);
}
async function H(e) {
	return T.get(`conversations/${e}/artifacts`).json();
}
async function U(e, t, n) {
	return T.get(`conversations/${e}/artifacts/${t}/versions`, { signal: n?.signal }).json();
}
async function W(e, t, n, r) {
	let i = {};
	return n !== void 0 && (i.version = n.toString()), T.get(`conversations/${e}/artifacts/${t}`, {
		searchParams: i,
		signal: r?.signal
	}).json();
}
async function G(e, t) {
	return T.get(s(e), { signal: t?.signal }).json();
}
async function K(e, t, n) {
	return T.post(`conversations/${e}/artifacts/${t}/share`, { searchParams: { version: n.toString() } }).json();
}
async function q(e, t, n) {
	return T.delete(`conversations/${e}/artifacts/${t}/share`, { searchParams: { version: n.toString() } }).json();
}
async function J(e, t) {
	return T.post(`conversations/${e}/files`, { json: t }).json();
}
async function Y(e, t, n) {
	return o(async () => new Promise((r, i) => {
		let a = new XMLHttpRequest();
		a.open("PUT", e), n && a.upload.addEventListener("progress", (e) => {
			e.lengthComputable && n(e.loaded / e.total * 100);
		}), a.addEventListener("load", () => {
			if (a.status >= 200 && a.status < 300) {
				let e = a.getResponseHeader("ETag");
				if (!e) {
					i(/* @__PURE__ */ Error("No ETag in response"));
					return;
				}
				r(e.replaceAll("\"", ""));
			} else i(/* @__PURE__ */ Error(`Upload failed with status ${a.status}`));
		}), a.addEventListener("error", () => {
			i(/* @__PURE__ */ Error("Network error during upload"));
		}), a.addEventListener("abort", () => {
			i(/* @__PURE__ */ Error("Upload aborted"));
		}), a.send(t);
	}), {
		retries: 3,
		onFailedAttempt(e) {
			console.warn(`Upload attempt ${e.attemptNumber} failed. ${e.retriesLeft} retries left.`);
		}
	});
}
async function X(e, t, n) {
	return T.put(`conversations/${e}/files/${t}/complete`, { json: { parts: n } }).json();
}
async function Z(e, t) {
	return T.get(`conversations/${e}/files`, { searchParams: t ? { origin: t } : void 0 }).json();
}
async function Q(e, t) {
	return T.get(`conversations/${e}/files/${t}`).json();
}
async function ne(e, t) {
	return T.get(`conversations/${e}/file-url`, { searchParams: {
		origin: t.origin,
		path: t.path
	} }).json();
}
async function re(e, t) {
	await T.delete(`conversations/${e}/files/${t}`);
}
async function ie() {
	return T.get("user").json();
}
async function ae() {
	return T.get("user/settings").json();
}
async function oe() {
	return T.get("models").json();
}
async function se() {
	return T.get("user/credits").json();
}
async function ce() {
	return T.get("user/plan").json();
}
async function le(e, t, n = "now") {
	return T.post("user/subscription", { json: {
		planId: e,
		clientToken: t,
		at: n
	} }).json();
}
async function ue() {
	return T.post("user/subscription/cancellation").json();
}
async function de() {
	return T.delete("user/subscription/cancellation").json();
}
async function fe() {
	await T.delete("user/subscription/scheduled");
}
async function pe() {
	return T.get("organizations").json();
}
async function me(e) {
	return T.post("organizations", { json: { name: e } }).json();
}
async function he(e, t, n) {
	return T.patch(`organizations/${e}/members/${t}`, { json: { role: n } }).json();
}
async function ge(e, t) {
	await T.delete(`organizations/${e}/members/${t}`);
}
async function _e(e, t) {
	return T.patch(`organizations/${e}`, { json: { name: t } }).json();
}
async function ve(e) {
	await T.delete(`organizations/${e}`);
}
async function ye(e) {
	return T.get(`organizations/${e}`).json();
}
async function be(e) {
	return T.get(`organizations/${e}/invitations`).json();
}
async function xe(e, t) {
	return T.post(`organizations/${e}/invitations`, {
		json: { email: t },
		retry: 0
	}).json();
}
async function Se(e, t) {
	await T.delete(`organizations/${e}/invitations/${t}`);
}
async function Ce() {
	return T.get("user/invitations").json();
}
async function we(e) {
	return T.post(`user/invitations/${e}/accept`).json();
}
async function Te(e) {
	await T.delete(`user/invitations/${e}`);
}
async function Ee(e) {
	return T.put("user/settings", { json: e }).json();
}
async function De(e) {
	return T.get("skills", { signal: e?.signal }).json();
}
async function $(e) {
	let t = new FormData();
	for (let { path: n, file: r } of e) t.append(n, r);
	return T.post("skills", { body: t }).json();
}
async function Oe(e, t) {
	return T.put(`skills/${e}/availability`, { json: { available: t } }).json();
}
async function ke(e, t) {
	return T.post(`skills/${e}/rename`, { json: { newSlug: t } }).json();
}
async function Ae(e, t) {
	let n = new FormData();
	for (let { path: e, file: r } of t) n.append(e, r);
	return T.put(`skills/${e}`, { body: n }).json();
}
async function je(e, t) {
	return T.delete(`skills/${e}/files`, { searchParams: { path: t } }).json();
}
async function Me(e, t) {
	let { files: n } = await T.get(`skills/${e}/files`, { signal: t?.signal }).json();
	return n;
}
async function Ne(e, t, n) {
	return T.get(`skills/${e}/files/content`, {
		searchParams: { path: t },
		signal: n?.signal
	}).text();
}
async function Pe(e) {
	return T.post(`skills/${e}/versions`).json();
}
async function Fe(e) {
	await T.delete(`skills/${e}`);
}
//#endregion
export { Z as $, ye as A, D as B, W as C, oe as D, A as E, De as F, xe as G, B as H, ie as I, p as J, h as K, se as L, G as M, Ne as N, Ce as O, Me as P, H as Q, ce as R, _ as S, I as T, Q as U, z as V, J as W, m as X, ee as Y, U as Z, ve as _, Ee as _t, f as a, ke as at, R as b, de as bt, le as c, S as ct, M as d, K as dt, L as et, me as f, V as ft, re as g, Ae as gt, N as h, he as ht, O as i, _e as it, be as j, pe as k, X as l, b as lt, Te as m, P as mt, d as n, F as nt, fe as o, ne as ot, $ as p, q as pt, u as q, we as r, ge as rt, ue as s, Se as st, l as t, Pe as tt, k as u, Oe as ut, Fe as v, Y as vt, j as w, v as x, je as y, te as yt, ae as z };

//# sourceMappingURL=api-HJB0sydk.js.map